import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  popper: {
    '& .MuiTooltip-tooltip': {
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      borderRadius: 0,
      marginBottom: 0,
      marginTop: theme.spacing(0.875),
    },
  },
}));

export interface StudioToolbarTooltipProps
  extends Pick<TooltipProps, 'title' | 'children' | 'placement' | 'open'> {}

const StudioToolbarTooltip = ({
  title,
  children,
  ...rest
}: StudioToolbarTooltipProps) => {
  const { classes } = useStyles();
  return (
    <Tooltip title={title} classes={{ popper: classes.popper }} {...rest}>
      {children}
    </Tooltip>
  );
};

export default StudioToolbarTooltip;
